import { useEnabledWheelByRarity } from './wheel/useEnabledWheelByRarity';

export const useIsEnabledSorareWheel = () => {
  const enabledWheelByRarity = useEnabledWheelByRarity();

  return enabledWheelByRarity.limited || enabledWheelByRarity.common;
};
